import { uc, pro } from './http.service';

export const apiUc = {
    /**
     * 检查是否登录
     * */
    checkLogin() {
        return uc.get('/uc/uc/open/login/check', { });
    },
    getTicket() {
        return uc.get('/uc/uc/open/ticket/get', { });
    },
    proLogin(data) {
        return pro.post('/pro/v1/users/login', { data });
    },
    getUserInfo() {
        return uc.get('/uc/uc/open/user/get', {});
    },
    //获取用户NFT信息
    getUserNFTInfo() {
        return pro.get('/hbg/v1/hbg/myhome/personalCenter', {});
    },
    //退出登录
    ucLogout() {
        return uc.get("/uc/uc/open/logout", {
            params:{
                restOptions: {
                    reqInterceptorsIgnore: true
                }
            }
        });
    },
}
